export default {
  "common.brand": "USFanslink",
  "nav.home": "Home",
  "nav.spreadsheet": "Spreadsheet",
  "nav.creators": "Creators",
  "nav.reviews": "Reviews",
  "nav.shipping": "Shipping",
  "nav.coupons": "Coupons",
  "nav.guides": "Guides",
  "nav.shoppingGuide": "Shopping Guide",

  "hero.badge": "Updated resources · Organized information",
  "hero.title": "USFans Spreadsheet – Explore Creators, Reviews & Resources",
  "hero.subtitle": "Find useful USFans information in one organized resource hub. Explore the USFans Spreadsheet, creator directory, reviews, shipping guides, coupons, warehouse information and the latest updates.",
  "hero.ctaSpreadsheet": "usfans spreadsheet",
  "hero.ctaBuyNow": "buy it now",
  "hero.dropdownLabel": "Jump to a category",
  "hero.dropdownPlaceholder": "Select a category…",
  "hero.trust": "Updated resources • Organized information • Safety-focused • Easy to explore",

  "categories.title": "Browse Popular Categories",
  "categories.subtitle": "Jump straight to the products you are looking for on the USFans spreadsheet store.",

  "categories.shoes": "Shoes",
  "categories.hoodies": "Hoodies/Sweaters",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jackets",
  "categories.pants": "Pants/Shorts",
  "categories.headwear": "Headwear",
  "categories.sets": "Sets",
  "categories.underwear": "Underwear/Underpants",
  "categories.jersey": "Jersey",
  "categories.accessories": "Accessories",
  "categories.bags": "Bags",
  "categories.belts": "Belts",
  "categories.perfumes": "Perfumes",
  "categories.other": "Other Stuff",

  "content.eyebrow": "USFans Spreadsheet Hub",
  "content.title": "What Is the USFans Spreadsheet?",
  "content.p1": "The USFans Spreadsheet is a single, organized resource that brings together USFans-related information in one easy place. Instead of searching across many different pages, visitors can find creators, reviews, shipping details, coupons and warehouse guidance gathered into a clear and searchable structure.",
  "content.p2": "At the heart of this hub is the creator directory. Each creator is listed with their category, available information and the latest update status, so you can quickly understand who is active and what kind of content they offer.",
  "content.sub1": "How to Use the Spreadsheet",
  "content.p3": "Start by choosing a category from the dropdown above. Each category links to a dedicated section of the main store, so you can go directly to the products that match your interest — whether that is shoes, jerseys, accessories or anything else in the catalog.",
  "content.sub2": "Reviews, Shipping and Coupons",
  "content.p4": "Beyond the directory, the hub also organizes practical guides. You can read reviews to understand the platform, check shipping costs before you order, and look for current coupon and discount information. Everything is collected so you do not have to hunt for it.",
  "content.sub3": "Safety and Transparency",
  "content.p5": "This site is an independent resource hub and is not the official USFans website. We focus on keeping information organized and easy to verify, so you can explore with confidence and follow links to the main store when you are ready to browse.",

  "article.ctaTitle": "Want the full picture?",
  "article.ctaText": "Read our complete USFans Spreadsheet guide for a deeper look at the creator directory, reviews, shipping and more.",
  "article.ctaButton": "Read the full guide",

  "articles.title": "USFans Pillar Guides & Articles",
  "articles.subtitle": "In-depth, independent guides covering reviews, shipping, coupons, warehouse, safety and more.",
  "articles.readMore": "Read guide",

  "footer.tagline": "An independent resource hub for USFans Spreadsheet information.",
  "footer.navTitle": "Explore",
  "footer.categoriesTitle": "Categories",
  "footer.disclaimer": "USFanslink is an independent resource hub and is not affiliated with the official USFans website.",
  "footer.rights": "All rights reserved."
};